import { render, staticRenderFns } from "./ColumnsSelectionDialog.vue?vue&type=template&id=16f19c96"
import script from "./ColumnsSelectionDialog.vue?vue&type=script&lang=js"
export * from "./ColumnsSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports